import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CookieWrapperService {
  private expires = 1;
  private path = '/';

  constructor(
    private cookieService: CookieService
  ) { }

  getExpires() {
    var date = new Date();
    date.setTime(date.getTime()+(this.expires*60*1000));
    return date;
  }

  setAccessTokenCookie(accessToken) {
    this.cookieService.set('accessToken', accessToken, {
      expires: this.getExpires(),
      path: this.path
    });
  }

  setAdminAccessTokenCookie(adminAccessToken) {
    this.cookieService.set('adminAccessToken', adminAccessToken, {
      expires: this.getExpires(),
      path: this.path
    });
  }
}
